import React from 'react';
import Routes from './components/app/Router';

function App() {
  return <Routes />;
}

export default App;
